class NumberHelper {
    /**
     * @description To force the value to number
     */
    toNumber(numb) {
        return Number.isNaN(numb) ? 0 : Number(numb);
    }

    /**
     * @description To convert integer to decimal number 
     * @param {Number} numb 
     * @returns 
     */
    decimal(numb = 0) {
        return numb.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
    }
}

const numberHelper = new NumberHelper();

export default numberHelper;


// WEBPACK FOOTER //
// ./src/core/helpers/numberHelper.js